export default __webpack_public_path__ + "static/marina_j-9174753027309cd17026639e22dc8fb9.jpg";